import styled$1 from 'styled-components';
import { Spinner as Spinner$1 } from '@ccg/core';

var Spinner = styled$1(Spinner$1)``;

export default Spinner;
